import React, { useContext } from 'react';

import { media } from 'context';
import { Icon, Layout, Link, Text } from 'ds';
import { FURNITURE_PATH } from 'routes';

import { WidgetVariant } from './types';

interface Props {
  variant: WidgetVariant;
}

const FurnitureServiceWidget: React.FC<Props> = ({ variant }) => {
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Link href={FURNITURE_PATH} color="black" fullWidth fullHeight>
        <Layout
          width={167}
          direction="row"
          align="flex-end"
          justify="space-between"
          borderRadius={16}
          padding={12}
          color="white"
          gap={8}
          height="100%"
        >
          <Text size="body-xs" color="purple-gradient" semibold __style={{ verticalAlign: 'bottom' }}>
            Upgrade your office setup
          </Text>
          <Icon name="rightChevron" color="purple-gradient" size={30} />
        </Layout>
      </Link>
    );
  }

  if (variant === 'half') {
    return (
      <Link href={FURNITURE_PATH} color="black" fullWidth fullHeight>
        <Layout align="center" paddingX={16} gap={12} height="100%" color="white" borderRadius={16}>
          <Layout direction="column" gap={12}>
            <Text size="body-xs" color="purple-gradient" semibold>
              Upgrade your office setup
            </Text>
            <Layout paddingX={12} paddingY={4} borderRadius={16} color="purple-gradient" width="fit-content">
              <Text size="body-xs" color="white" semibold>
                Shop furniture
              </Text>
            </Layout>
          </Layout>
          <Icon name="chair" color="purple-gradient" size={32} />
        </Layout>
      </Link>
    );
  }

  return (
    <Link href={FURNITURE_PATH} color="black" fullWidth fullHeight>
      <Layout height="100%" direction="column" justify="center" align="center" gap={16} color="white" borderRadius={16}>
        <Layout direction="column" align="center" gap={4}>
          <Icon name="chair" color="purple-gradient" size={32} />
          <Text size="body-md" color="purple-gradient" align="center" semibold>
            Take advantage of
            <br />
            exclusive pricing.
          </Text>
        </Layout>
        <Layout borderRadius={16} color="purple-gradient" paddingX={12} paddingY={4} display="inline-flex">
          <Text size="body-xs" color="white" semibold>
            Shop furniture
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default FurnitureServiceWidget;
